export default __webpack_public_path__ + "static/media/GrayCross.006f0f51.svg";